<template>
  <CModal
    :closeOnBackdrop="false"
    :show.sync="modal"
    :no-close-on-backdrop="false"
    :centered="true"
    title=""
    size="lg"
    color="dark"
  >
    <CCard>
      <CCardBody>
        <CForm>
          <span v-for="item in personalAuthorityItems" :key="item.page_id">
            <CRow>
              <CCol md="5">
                <label>
                  {{ item.page_name }}
                </label>
              </CCol>
              <CCol>
                <CSelect
                  :value.sync="item.operation_authority"
                  horizontal
                  :options="item.options"
                  placeholder="選択してください"
                  @change="applyChanges"
                />
              </CCol>
            </CRow>
          </span>
        </CForm>
      </CCardBody>
    </CCard>
    <template #header>
      <h6 class="modal-title">個人閲覧権限設定</h6>
      <CButtonClose @click="closeModal" class="text-white" />
    </template>
    <template #footer>
      <CButton @click="update" color="success">更新</CButton>
    </template>
  </CModal>
</template>

<script>
import operation_authority from "../../../../definition/operation-authority.json";
import page from "../../../../definition/page.json";
import constMsg from "../../../../definition/const/const_message.js";

export default {
  name: "personalAuthorityEditModal",
  data() {
    return {
      modal: false,
      updateFlag: false,
      pageList: page,
      inputItem: {},
    };
  },
  watch: {
    visible: {
      handler: function () {
        this.modal = this.visible;
        if (this.visible) {
          // プルダウン選択肢を画面に応じて絞り込む
          this.personalAuthorityItems.forEach((item) => {
            var options = this.choicesFilter(
              false,
              item.operation_authority_list,
              operation_authority,
              "value"
            );
            item.options = options;
          });
        }
      },
    },
  },
  props: {
    visible: {
      type: Boolean, // Boolean型に限定
      required: true, // 必須項目
    },
    personalAuthorityItems: {
      type: Array,
    },
    userId: {
      type: String,
    },
  },
  methods: {
    applyChanges(){
      this.updateFlag = true;
    },
    closeModal() {
       console.log(this.updateFlag)
      if(this.updateFlag == true){
      var result = confirm('内容が変更されています。ウインドウを閉じますか？');
      if(result === false) {
        return;
      }
      }
      this.updateFlag = false;
      this.modal = false;
      this.$emit("close");
    },
    async update() {
      var id = this.userId;
      // パラメータに値を含める
      this.inputItem = {
        user_id: this.userId,
        login_user_id: this.$store.state.loginUser.user_id,
        authorities: [],
      };
      // 個人閲覧権限設定情報をパラメータに含める
      var authority = {};
      this.personalAuthorityItems.forEach((item) => {
        authority = {
          page_id: item.page_id,
          operation_authority: item.operation_authority,
        };
        this.inputItem.authorities.push(authority);
      });
      // 更新処理
      const ret = await this.updatePersonalauthorities(id, this.inputItem);
      // 画面クローズ
      this.modal = false;
      this.$emit("close", ret);
    },
    async updatePersonalauthorities(id, param) {
      let ret = {};
      await this.$axios
        .put("/api/v1/personalauthorities/" + id, param)
        .then((res) => {
          ret.alertClr = "success";
          ret.alertMsg = constMsg.I0003_JP;
        })
        .catch((e) => {
          ret.alertClr = "danger";
          ret.alertMsg = e.response.data.message;
        });
      return ret;
    },
    /**
     * 配列から特定のオブジェクトを取り除くまたは、抽出する
     * @param {*} option true：取り除く、false：抽出する
     * @param {*} filterList 取り除くまたは、抽出するオブジェクトリスト
     * @param {*} targetList 対象のオブジェクトリスト
     * @param {*} key オブジェクト内のプロパティ名
     */
    choicesFilter(option, filterList, targetList, key) {
      var resultList = [];
      // フィルタ条件を設定
      var callbacksArray = [];
      if (option) {
        // 条件を取り除くに設定
        filterList.forEach((e) => {
          callbacksArray.push((item) => item[key] != e);
        });
        // フィルターリストがない場合、対象のオブジェクトリストを
        // フィルタ実行
        callbacksArray.forEach((callback) => {
          targetList = targetList.filter((item) => callback(item));
        });
        resultList = targetList;
      } else {
        // 条件を抽出に設定
        filterList.forEach((e) => {
          callbacksArray.push((item) => item[key] == e);
        });
        // フィルタ実行
        callbacksArray.forEach((callback) => {
          var res = targetList.find((item) => callback(item));
          if (res) {
            resultList.push(res);
          }
        });
      }
      // フィルタ後のリストを返す
      return resultList;
    },
  },
};
</script>